//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { IContainer, IProps, IState } from "./ChromeNavTabsTypes";
// util
import { track, TrackingEvents } from "#webapp/src/util/analytics.util";
import { ChromeAppWrapperView } from "#webapp/src/util/chrome-extension.util";
// state
import { setActiveView } from "#webapp/src/state/actions/chrome-extension.actions";
import { setSelectedTabView } from "#webapp/src/state/actions/nav-tabs.actions";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
// material-ui
import { Badge, Tab, Tabs } from "@material-ui/core";

//////////////////
// COMPONENT
//////////////////
class ChromeNavTabsCmpt extends React.Component<IProps, IState> {
  // ~-~-~-~-~-~-~-
  // Event Handlers
  // ~-~-~-~-~-~-~-
  private onTabChange = (selectedTabView: ChromeAppWrapperView) => {
    this.props.setSelectedTabView(selectedTabView);
    this.props.setActiveView(selectedTabView);

    track(TrackingEvents.CHROME_MENU.SELECT_TAB, { selectedTabView });
  };

  // ~-~-~-~-~-~-~-
  // Rendering
  // ~-~-~-~-~-~-~-
  private renderTab = (tab: any, i: number) => {
    const {
      suggestionFeedNotificationCount,
      assistantFeedCardNotificationCount,
      autopilotFeedStatusDefragCardNotificationCount,
    } = this.props;

    const cwId = `sidebar-tab-${tab.label}`;

    const notificationCount =
      suggestionFeedNotificationCount +
      autopilotFeedStatusDefragCardNotificationCount +
      assistantFeedCardNotificationCount;

    if (notificationCount && tab.view === ChromeAppWrapperView.Feed) {
      return (
        <Tab
          cw-id={cwId}
          key={i}
          value={tab.view}
          label={
            <Badge
              badgeContent={notificationCount}
              color={"primary"}
              classes={{
                badge: "cw-top-[9px] -cw-right-4 cw-bg-warning-emphasis cw-text-onEmphasis",
              }}
            >
              {tab.label}
            </Badge>
          }
          onClick={() => this.onTabChange(tab.view)}
        />
      );
    }

    return (
      <Tab
        cw-id={cwId}
        key={i}
        value={tab.view}
        label={tab.label}
        onClick={() => this.onTabChange(tab.view)}
      />
    );
  };
  public render() {
    const tabMatch = this.props.tabs.find((tab) => tab.view === this.props.activeView);

    let selectedTabView = this.props.selectedTabView;
    // select the tab of the active view if its within our tab set, otherwise use selected tab view
    if (tabMatch) {
      selectedTabView = this.props.activeView;
    }

    const shouldHideDayView =
      this.props.mode === "webapp" && !window.matchMedia("(max-width: 768px)").matches;

    return (
      <Tabs variant="fullWidth" value={selectedTabView}>
        {this.props.tabs.map((tab, i) =>
          shouldHideDayView && tab.view === ChromeAppWrapperView.Day
            ? null
            : this.renderTab(tab, i),
        )}
      </Tabs>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    activeView: state.webExtension.activeView,
    mode: state.webExtension.mode,
    suggestionFeedNotificationCount: state.webExtension.suggestionFeedNotificationCount,
    autopilotFeedStatusDefragCardNotificationCount:
      state.webExtension.autopilotFeedStatusDefragCardNotificationCount,
    ...state.navTabs,
    assistantFeedCardNotificationCount: state.webExtension.assistantFeedCardNotificationCount,
  };
}

export const ChromeNavTabs = connect(mapStateToProps, {
  setSelectedTabView,
  setActiveView,
})(ChromeNavTabsCmpt);
